module.exports = __webpack_public_path__ + "img/18000.11aa2b3e.jpg";